{
  "confirmationNumber": "Nomor Konfirmasi {number}",
  "dateTimeRange": "{date} dari {startTime} hingga {endTime}"
}
